export interface SSOConfigUpdate {
  provider?: 'google' | 'okta' | 'azure' | 'custom' | 'github';
  status?: 'active' | 'inactive';
  config: {
    client_id: string;
    client_secret: string;
    domain?: string;
    metadata_url?: string;
  };
}

export interface Profile {
  id: string;
  email: string;
  full_name?: string;
  role: 'employer' | 'admin';
  company_id?: string;
  candidate_location?: string;
  created_at: string;
  updated_at: string;
}

export interface Company {
  id: string;
  name: string;
  description: string;
  logo_url?: string;
  website?: string;
  company_location: string;
  subscription_id?: string;
  sso_config_id?: string;
  created_at: string;
  updated_at: string;
}

export interface Job {
  id: string;
  company_id: string;
  title: string;
  description: string;
  requirements: string[];
  job_location: string;
  type: 'full-time' | 'part-time' | 'contract';
  work_location: 'remote' | 'office' | 'hybrid';
  salary_range?: string;
  status: 'draft' | 'published' | 'closed';
  external_source?: string;
  external_id?: string;
  external_url?: string;
  created_at: string;
  updated_at: string;
  companies?: {
    name: string;
  };
}

export interface Subscription {
  id: string;
  plan: 'basic' | 'pro' | 'enterprise';
  status: 'active' | 'cancelled' | 'expired';
  features: string[];
  price: number;
  billing_cycle: 'monthly' | 'yearly';
  start_date: string;
  end_date?: string;
  created_at: string;
  updated_at: string;
}

export interface SSOConfig {
  id: string;
  provider: 'google' | 'okta' | 'azure' | 'custom' | 'github';
  status: 'active' | 'inactive';
  config: {
    client_id: string;
    client_secret: string;
    domain?: string;
    metadata_url?: string;
  };
  created_at: string;
  updated_at: string;
}

export type AdminRole = 'founder' | 'admin' | 'moderator';

export interface AdminPermissions {
  manageUsers: boolean;
  manageSubscriptions: boolean;
  manageSSO: boolean;
  viewAnalytics: boolean;
  viewHealth: boolean;
  manageSystem: boolean;
  manageAdmins: boolean;
  editPermissions: boolean;
  configureBot: boolean;
  editRoles: boolean;
}

export interface Application {
  id: string;
  status: string;
  created_at: string;
  updated_at: string;
  application_data: {
    job_title: string;
    candidate_name: string;
    [key: string]: unknown;
  };
  job_id: string;
  candidate_id: string;
  company_name: string;
}

export const ROLE_PERMISSIONS: Record<AdminRole, AdminPermissions> = {
  founder: {
    manageUsers: true,
    manageSubscriptions: true,
    manageSSO: true,
    viewAnalytics: true,
    viewHealth: true,
    manageSystem: true,
    manageAdmins: true,
    editPermissions: true,
    configureBot: true,
    editRoles: true
  },
  admin: {
    manageUsers: true,
    manageSubscriptions: true,
    manageSSO: true,
    viewAnalytics: true,
    viewHealth: true,
    manageSystem: false,
    manageAdmins: false,
    editPermissions: false,
    configureBot: false, // Changed to false - only founders can configure bot
    editRoles: false
  },
  moderator: {
    manageUsers: false,
    manageSubscriptions: true,
    manageSSO: true,
    viewAnalytics: false,
    viewHealth: true,
    manageSystem: false,
    manageAdmins: false,
    editPermissions: false,
    configureBot: false,
    editRoles: false
  },
};